import AxL from './axl';
import { HelperCanvas } from './HelperCanvas';
import { getComplementaryColor, hexToRgb } from './utils';

const SHOWN_CLASS = 'shown';

class HelperMessages {
  constructor(axl, playback) {
    this.color = '#ffffff';
    this.boxShadowColor = '#000000';
    this.shareShown = false;
    this.shareDone = false;
    this.startHelperShown = false;
    this.instrumentsShown = false;
    this.instrumentIndex = undefined;
    this.axl = axl;
    this.atmosphereData = null;
    this.helperCanvas = new HelperCanvas(playback);

    this.instrumentsMessageElem = document.getElementById('helper-instruments');
    this.sharingMessageElem = document.getElementById('helper-sharing');
    this.instrumentButtonsElem = document.getElementById('instrument-buttons');
    this.instrumentHighlightElem = document.getElementById(
      'instrument-buttons-highlight'
    );

    this.messages = [this.instrumentsMessageElem, this.sharingMessageElem];

    for (const elem of this.messages) {
      const closeBtns = elem.getElementsByClassName('helper-closebtn');
      elem.bgArrows = elem.getElementsByClassName('bg-arrow');
      if (closeBtns.length) {
        elem.closeBtn = closeBtns[0];
        closeBtns[0].addEventListener('click', (e) => {
          this.hideMessage(elem);
          if (elem == this.sharingMessageElem) {
            this.shareDone = true;
          }
          if (this.axl) {
            this.axl.sendMessage(AxL.ChildToHost.TRACK, {
              action:
                elem == this.instrumentsMessageElem
                  ? 'close_helper_intruments_message'
                  : 'close_helper_sharing_message',
              label: 'OK',
            });
          }
        });
      }
    }
  }

  resize() {
    this.helperCanvas.resize();
    this.instrumentHighlightElem.style.width = `${
      this.instrumentButtonsElem.clientWidth + 8
    }px`;
  }

  changeColor(overlayColor, atmosphereData, instrumentColor) {
    this.color = overlayColor;
    const complementaryColor = getComplementaryColor(this.color);
    const complementaryColorRgb = hexToRgb(complementaryColor);
    this.boxShadowColor = `rgba(${complementaryColorRgb[0]}, ${complementaryColorRgb[1]}, ${complementaryColorRgb[2]}, 0.5)`;
    this.helperCanvas.changeColor(
      instrumentColor,
      atmosphereData,
      complementaryColor
    );
    for (const elem of this.messages) {
      this.colorMessage(elem);
    }
  }

  shared() {
    this.shareDone = true;
    this.shareShown = true;
    this.hideMessage(this.sharingMessageElem);
  }

  closeAll() {
    for (const elem of this.messages) {
      this.hideMessage(elem);
    }
  }

  instrumentChanged(index) {
    if (this.instrumentIndex !== undefined && this.instrumentIndex !== index) {
      this.instrumentsShown = true;
    }
    this.instrumentIndex = index;
    this.hideMessage(this.instrumentsMessageElem);
  }

  showMessage(elem) {
    this.colorMessage(elem);
    elem.classList.add(SHOWN_CLASS);
  }

  changeAtmosphere(data) {
    this.atmosphereData = data;
    if (!this.shareDone) {
      this.shareShown = false;
    }
  }

  colorMessage(elem) {
    elem.style.color = this.color;
    if (elem.closeBtn) {
      elem.closeBtn.style.color = this.color;
    }
    if (elem.bgArrows) {
      for (const bgArrow of elem.bgArrows) {
        bgArrow.style.backgroundColor = this.color;
      }
    }
  }

  hideMessage(elem) {
    elem.classList.remove(SHOWN_CLASS);
    if (elem == this.instrumentsMessageElem) {
      this.instrumentHighlightElem.classList.remove('shown');
    }
  }

  showInstrumentHelper() {
    if (!this.instrumentsShown) {
      this.instrumentsShown = true;
      this.showMessage(this.instrumentsMessageElem);
      this.instrumentHighlightElem.style.width = `${
        this.instrumentButtonsElem.clientWidth + 8
      }px`;
      this.instrumentHighlightElem.style.borderColor = this.color;
      this.instrumentHighlightElem.style.boxShadow = `0px 0px 36px 26px ${this.boxShadowColor}`;
      this.instrumentHighlightElem.classList.add('shown');
    }
  }

  showSharingHelper() {
    if (!this.shareShown) {
      this.shareShown = true;
      this.showMessage(this.sharingMessageElem);
    }
  }

  showStartCanvasHelper() {
    if (!this.startHelperShown) {
      this.startHelperShown = true;
      this.helperCanvas.show();
    }
  }

  hideStartCanvasHelper() {
    this.helperCanvas.hide();
  }
}
export { HelperMessages };
